<template>
  <div class="flex border-l-4 warning-dark shadow-md mb-2 pt-26 pb-16 md:py-16 px-3 m-auto w-full md:w-550 relative">
    <i v-if="! $mq.md" class="fas fa-times text-white absolute right-0 mr-16" @click="$emit('close')"></i>
    <div class="w-full grid" :class="buttonSettings.displayMobile ? 'grid-cols-4' : 'grid-cols-1 md:grid-cols-4'">
      <div :class="buttonSettings.displayMobile ? 'col-span-3' : 'md:col-span-3'">
        <i class="fas fa-exclamation bg-orange float-left rounded-full text-white text-10 top-16 px-8 py-4"></i>
        <div class="text-white max-w-xs ml-28">
          <p class="mb-10 font-bold text-16">{{ title }}</p>
          <div class="font-thin text-14" v-html="message"></div>
          <ul v-if="items && items.length > 0" class="pl-32 mt-8 list-disc">
            <li v-for="item in items">{{ item }}</li>
          </ul>
        </div>
      </div>

      <div class="text-white text-16 text-right pt-8"
        :class="buttonSettings.displayMobile ? 'block' : 'hidden md:block'">

        <button class="p-16 border rounded border-transparent hover:bg-0000004D" @click="buttonClick">
          {{ buttonSettings.text !== null ? buttonSettings.text : 'CLOSE'}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WarningDark",
  props: {
    title: {
      required: true,
      type: String
    },
    message: {
      required: true,
      type: String
    },
    items: {
      required: false,
      type: Array
    },
    buttonSettings: {
      required: false,
      type: Object
    }
  },

  methods: {
    buttonClick () {
      if (this.buttonSettings.type === 'link') {
        window.location.href = this.buttonSettings.href
      } else {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped>
.warning-dark {
  background-color: #3C3838;
  border-color: #ff6700;
}
</style>
